import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  StrapiComponentHero2025,
  StrapiTextSubText,
} from '../section/interfaces';
import { getBackground } from '@/theme/backgrounds';
import {
  TextWithDropShadow,
  TextWithDropShadowColor,
} from '../TextWithDropShadow';
import Button from '../common/Button';
import { useRouter } from 'next/navigation';

interface Props {
  props: Partial<StrapiComponentHero2025>;
  className?: string;
  children?: ReactNode;
}

export const Hero2025: FC<Props> = ({
  props: { text, data, corners, background, padding, textPosition, buttons },
  className,
}) => {
  const router = useRouter();
  const textColor = (item: StrapiTextSubText): TextWithDropShadowColor => {
    const twColor =
      item.color?.TWName && item.color?.TWWeight
        ? `text-${item.color?.TWName}-${item.color?.TWWeight}`
        : undefined;

    return {
      text: twColor || item?.color?.color || 'text-white',
      shadow: 'text-white',
    };
  };

  const contentAlignmanet =
    textPosition === 'middle'
      ? 'items-center  justify-center'
      : textPosition === 'top'
        ? 'items-start justify-start'
        : 'items-end justify-end';

  const backgroundStyle = background?.url
    ? {
        backgroundImage: `url(${background.url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    : { background: background?.style && getBackground(background.style) };

  const rounderedClass = [
    corners?.tl ? 'rounded-tl-3xl' : '',
    corners?.tr ? 'rounded-tr-3xl' : '',
    corners?.bl ? 'rounded-bl-3xl' : '',
    corners?.br ? 'rounded-br-3xl' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      style={backgroundStyle}
      className={twMerge(
        'mrc-info-card-banner flex-col',
        contentAlignmanet,
        className,
        'min-h-[800px]',
        'pt-[350px] ',
        clsx(rounderedClass)
      )}
    >
      <div className={`pl- flex w-full flex-col gap-y-6 p-7 pb-0 text-center`}>
        {text &&
          text.map((item, index) => (
            <TextWithDropShadow
              key={index}
              text={item.text}
              color={textColor(item)}
              displayShadow={item.shadow}
            />
          ))}
      </div>
      <div className=''>
        {buttons && (
          <div className='flex flex-row items-center justify-center gap-2 pt-10'>
            <div className='flex flex-col items-center justify-center rounded-xl border-2 bg-white bg-opacity-30 p-2 sm:flex-row md:flex-row md:rounded-full'>
              {buttons.map((item, index) => {
                if (item.disabled) return null;

                return (
                  <Button
                    key={index}
                    title={item.label}
                    className='pill-button m-1 sm:m-0 sm:mx-1 md:mt-0'
                    onClick={() => router.push(item.href)}
                  >
                    {item.label}
                  </Button>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
